import React from 'react'

const Footer = () => {
  return (
    <section>
        <div className='bg-[#0B0D17] pb-16 pt-4'>
            <h1 className='text-center font-[roboto] text-3xl text-[#5B5B5B] font-extrabold'>
            <span className='text-orange-400'>FOOD</span>  NETWORK
            </h1><br /><br />

            <p className='text-center font-normal text-base text-white'>
            Eat healthy to live healthy. <br className='lg:hidden' /> Live healthy to live happy.
            </p>
        </div>
    </section>
  )
}

export default Footer